import { render, staticRenderFns } from "./ChatMensagens.vue?vue&type=template&id=45c7a03c&scoped=true"
import script from "./ChatMensagens.vue?vue&type=script&lang=js"
export * from "./ChatMensagens.vue?vue&type=script&lang=js"
import style0 from "./ChatMensagens.vue?vue&type=style&index=0&id=45c7a03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7a03c",
  null
  
)

export default component.exports